import i18n from 'i18next';
import {usePage} from "@inertiajs/inertia-react";
import styles from '../../../sass/components/TrialBanner.module.scss';
import {useReducer} from "react";
import GeneralPurchaseModal from "@/Pages/BuyFlow/GeneralPurchaseModal";
import {ButtonPrimary} from "@/Components/Buttons/ButtonPrimary";
import { navigateToURL} from '@/Utilities/Util';

function reducer(state, action) {
    switch(action.type) {
        case "showCheckoutModal":
            return { ...state, showCheckoutModal: action.payload.showCheckoutModal }
        default:
            return state;
    }
}

export function TrialBanner({trialCount}) {

    const [state, dispatch] = useReducer(reducer,
        {
            showCheckoutModal: false
        });

    const isAdmin = usePage().props.auth.current_organization.is_admin ?? false;
    let hasCustomSalesForceOffer = usePage().props.auth.current_organization.has_custom_salesforce_offer;
    const features = usePage().props.features;
    const salesloftURL = usePage().props.salesloft_url;

    return (
        <>
            {
                hasCustomSalesForceOffer ? (
                    <ButtonPrimary className={styles.trialBanner} onClick={() => { !salesloftURL ?
                        dispatch({ type: "showCheckoutModal", payload: { showCheckoutModal: true }}): navigateToURL(salesloftURL)
                    }}>
                        <div className={styles.upgrade}>
                            {i18n.t("trial-banner.complete-purchase")}
                        </div>
                    </ButtonPrimary>
                ) : isAdmin && trialCount > 0 && features['trials'] ? (
                    <ButtonPrimary dataTestid="trial_banner-button-subscribe" className={styles.trialBanner} onClick={() => { !salesloftURL ?
                        dispatch({ type: "showCheckoutModal", payload: { showCheckoutModal: true }}): navigateToURL(salesloftURL)
                    }}>
                        <div className={styles.trialText}>
                            {`${i18n.t("trial-banner.activated-trials")} ${trialCount} ${trialCount === 1 ? i18n.t('trial-banner.module.singular') : i18n.t('trial-banner.module.plural')}`}
                        </div>
                        <div className={styles.upgrade}>
                            {i18n.t("trial-banner.upgrade")}
                        </div>
                    </ButtonPrimary>
                ) : null
            }

            { state.showCheckoutModal ? <GeneralPurchaseModal state={state} dispatch={dispatch}/> : null }
        </>
    )
}
